globalThis.__version__ = '1.4.2'
// import getSidebarMap from './sidebarMap'
import { userLoginInfo } from '@/apiUtils'
import store from '@/store'

let timer = null
/** 续活 */
export async function autoLogin() {
	const info = await userLoginInfo()
	if (info.code === 0) {
		store.commit('setUserInfo', {
			id: info.id,
			loginState: info.loginState,
			name: info.name
		})
	}
	if (timer) {
		clearTimeout(timer)
		timer = null
	}
	timer = setTimeout(autoLogin, 12000)
}

/**
 * 刷新侧边栏和权限
 * @param {boolean} forceRefresh 是否强制刷新, false 如果权限存在则不刷新, true 强制刷新, 默认为 false
 */
export async function refreshSidebar(forceRefresh = false) {
	Promise.resolve().then(async () => {
		if (process.env.NODE_ENV !== 'development') {
			// 保持活跃
			autoLogin()
		} else {
			const info = await userLoginInfo()
			if (info.code === 0) {
				store.commit('setUserInfo', {
					id: info.id,
					loginState: info.loginState,
					name: info.name
				})
			}
		}
	})
	// const { organization, personnelInfo, contractInfo, highBaseInfo, systemSetUp } = getSidebarMap()
	// if (!store.state.powerList.length || forceRefresh) {
	// 	const { data = [] } = await getCurrentAdminPowerList()
	// 	store.commit('setPowerList', data)
	// }
	// sidebarMap.organization = filterPermissionTree(organization, store.state.powerList)
	// sidebarMap.personnelInfo = filterPermissionTree(personnelInfo, store.state.powerList)
	// sidebarMap.contractInfo = filterPermissionTree(contractInfo, store.state.powerList)
	// sidebarMap.highBaseInfo = highBaseInfo
	// // sidebarMap.highBaseInfo = filterPermissionTree(highBaseInfo, store.state.powerList)
	// sidebarMap.systemSetUp = filterPermissionTree(systemSetUp, store.state.powerList)
	// 调试开启
	// sidebarMap.organization = organization
	// sidebarMap.personnelInfo = personnelInfo
	// sidebarMap.contractInfo = contractInfo
	// sidebarMap.systemSetUp = systemSetUp
	// updateSidebar()
}
